export const schema = [
  {
    id: "/Page/Element/Type/Section",
    type: "object",
    properties: {
      // The entire page-to-section link. Not a foreign key anything enforces:
      // removing the section leaves this dangling and the renderer says
      // "Section not found", which is what the archived project did. Checking
      // it on delete would mean scanning every page in the organization.
      sectionId: {
        label: "Section",
        type: "string",
        default: "",
      },
    },
    required: [],
  },
];
